import React from 'react';
import styled from '@emotion/styled';

import { ReactComponent as IconFavouriteSelected } from './svg/iconFavouriteSelected.svg';
import { ReactComponent as IconFavouriteUnselected } from './svg/iconFavouriteUnselected.svg';

/* ======================================== */

const iconSize = 26;        // TODO theme
const iconSizeCompact = 20;

type TProps = {
    selected?: boolean;
    header?: boolean;
    compact?: boolean;
    callback?: () => void;
};

/* ======================================== */

/**
 * @private
 */
export const CellFavourite: React.FC<TProps> = (props) => {
    const { selected, header, compact, callback } = props;

    const StyledSpan = styled.span(
        () => ({
            cursor: callback ? 'pointer' : undefined,
            marginTop: compact ? -4 : 0,
            marginBottom: compact ? -4 : 0,

            '&>svg': {
                width: compact ? iconSizeCompact : iconSize,
                height: compact ? iconSizeCompact : iconSize,
                marginLeft: header ? -8 : undefined,
                marginRight: header ? -10 : undefined
            }
        })
    );
    
    return (
        <StyledSpan
            onClick={callback}
        >
            {selected || header
                ? <IconFavouriteSelected />
                : <IconFavouriteUnselected />
            }
        </StyledSpan>
    );
};
